// extracted by css-extract-rspack-plugin
export default {"wrapper":"AdCreateMenu-module__wrapper--ptkXn"};